import {Component, Input, TemplateRef} from '@angular/core';


@Component({
    selector: 'tfl-bo-editable-cell',
    template: `
        <div class="form-group">
            <label class="control-label col-sm-6 col-xs-12">
                {{ label | translate }}
            </label>
            <div class="col-sm-6 col-xs-12">
                <div *ngIf="!isEdit" class="form-control-static">
                    <ng-container *ngIf="value">{{value}}</ng-container>
                    <ng-container *ngIf="valueTmpl" [ngTemplateOutlet]="valueTmpl"></ng-container>
                </div>
                <div [hidden]="!isEdit" class="form-control-container">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `
})
export class EditableCellComponent {
    @Input() label: string;
    @Input() value: string;
    @Input() valueTmpl: TemplateRef<any>;
    @Input() isEdit = false;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/editable-cell/editable-cell.component.ts